import '../echarts-gl';

import '../component/grid3D';
import '../component/geo3D';
import '../component/globe';
import '../component/mapbox3D';
import '../component/maptalks3D';

import '../chart/bar3D';
import '../chart/line3D';
import '../chart/scatter3D';
import '../chart/lines3D';
import '../chart/polygons3D';
import '../chart/surface';
import '../chart/map3D';

import '../chart/scatterGL';
import '../chart/graphGL';
import '../chart/flowGL';
import '../chart/linesGL';